import {v4 as uuidv4} from 'uuid';
import {SearchThemeKeywordResultVo} from '../../common/shared/api/nicolas/vo/SearchThemeKeywordResultVo.interface';
import {SearchThemeKeywordSortTypeVo} from '../../common/shared/api/nicolas/vo/SearchThemeKeywordSortTypeVo.enum';
import {Maybe, SearchThemeKeyword, User} from '../generated/types';
import {createNormalListViewItem} from './NormalListViewItem';
import {createSearchSortType} from './SearchSortType';
import {createSortOption} from './SortOption';

export function createSearchThemeKeyword(
  userInfo: Maybe<User>,
  {
    cat_opt_list,
    filter_list,
    is_end,
    list,
    selected_cat_opt,
    selected_sort_opt,
    sort_opt_list,
    total_count,
  }: SearchThemeKeywordResultVo,
  page: number
): SearchThemeKeyword {
  const selectedSortOption = createSortOption({sortOptVo: selected_sort_opt});
  return {
    id: uuidv4(),
    total: total_count,
    categoryOptionList: cat_opt_list.map(opt =>
      createSortOption({sortOptVo: opt})
    ),
    isEnd: is_end,
    list: list.map(item => ({
      ...createNormalListViewItem(userInfo, {
        searchThemeKeywordItemSeriesDto: item,
      }),
    })),
    filterList: filter_list,
    selectedCategoryOption: createSortOption({sortOptVo: selected_cat_opt}),
    selectedSortOption: {
      ...selectedSortOption,
      param: createSearchSortType(
        selectedSortOption.param as SearchThemeKeywordSortTypeVo
      ),
    },
    sortOptionList: sort_opt_list
      .map(opt => createSortOption({sortOptVo: opt}))
      .map(opt => ({
        ...opt,
        param: createSearchSortType(opt.param as SearchThemeKeywordSortTypeVo),
      })),
    page,
  };
}
